export const rolDecimal = 6;
